var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseAccentColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5799 12.1822C12.8419 12.4447 12.4502 12.8457 12.1834 12.5786L7.0002 7.39599L1.817 12.5786C1.55133 12.8443 1.1582 12.4444 1.42047 12.1822L6.60367 6.99951L1.42047 1.81686C1.1565 1.55263 1.55303 1.15643 1.817 1.42038L7.0002 6.60302L12.1834 1.42038C12.4477 1.15643 12.8436 1.55263 12.5799 1.81686L7.39673 6.99951L12.5799 12.1822Z",
    fill: "#43927C",
    stroke: "#07251e",
    strokeWidth: 1.41667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseAccentColor);
export default __webpack_public_path__ + "static/media/close-accent-color.96e0a9605b02f903d2900ad1fe0c2a90.svg";
export { ForwardRef as ReactComponent };